module.exports = __webpack_public_path__ + "static-portal/img/ggd.a100906.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ggd.jpg
// module id = JZyu
// module chunks = 4